<script>
    import {csAvailableSupported, portalConfiguration, resourcesPath} from "../../stores.js";
    import Fa from "svelte-fa";
    import {faCircleQuestion} from "@fortawesome/free-regular-svg-icons";
    import {faExternalLinkAlt, faHeadset} from "@fortawesome/free-solid-svg-icons";
    import TokenAdministrationModal from "../modal/TokenAdministrationModal.svelte";

    let showCertificateAdministration = $state(false);

    let textRegistierenMitPostfach = "Registrieren mit Postfach";
    let textRegistierenOhnePostfach = "Registrieren ohne Postfach";
    let textZertifikateVerwalten = "Zertifikate verwalten";
</script>

<footer id="brak-footer">
    <a href="/beaportal" target="_blank" rel="noreferrer" class="brak-bea-logo">
        <img src={`${$resourcesPath}/img/logo_bea.svg`} alt="Logo: beA - zur Internetseite" />
    </a>

    <div class="brak-linkbanner">
        <div class="left" style="grid-row-start: 1; grid-row-end: 4">
            <a href={$portalConfiguration.support ?? ''} rel="noreferrer" target="_blank"><Fa icon={faHeadset} /> Support</a>
        </div>
        <div class="left" style="grid-row-start: 4; grid-row-end: 7">
            <a href={$portalConfiguration.help ?? ''} rel="noreferrer" target="_blank"><Fa icon={faCircleQuestion} /> Hilfe</a>
        </div>

        <div class="right" style="grid-row-start: 1; grid-row-end: 3">
            <a href="/beaportal/#/download" class="brak-external-link">Client Security herunterladen</a> <Fa icon={faExternalLinkAlt} /> <i class="fa fa-external-link-alt" aria-hidden="true"></i>
        </div>
        <div class="right" style="grid-row-start: 3; grid-row-end: 5">
            {#if $csAvailableSupported}
                <a href={$portalConfiguration.registrationWithPostbox ?? ''} class="brak-external-link" target="_blank">{textRegistierenMitPostfach}</a> / <a href={$portalConfiguration.registrationWithoutPostbox ?? ''} class="brak-external-link" target="_blank">{textRegistierenOhnePostfach}</a>  <Fa icon={faExternalLinkAlt} />
            {:else}
                <span class="disable">{textRegistierenMitPostfach} / {textRegistierenOhnePostfach} <Fa icon={faExternalLinkAlt} /></span>
            {/if}
        </div>
        <div class="right" style="grid-row-start: 5; grid-row-end: 7">
            {#if $csAvailableSupported}
                <button type="button" onclick={() => (showCertificateAdministration = true)} class="brak-external-link link-button">{textZertifikateVerwalten}</button> <Fa icon={faExternalLinkAlt} />
            {:else}
                <span class="disable">{textZertifikateVerwalten} <Fa icon={faExternalLinkAlt} /></span>
            {/if}
        </div>
    </div>

    <div class="brak-copyright" style="float: left;">
        {$portalConfiguration.copyright ?? ''}
        <a target="_blank" href={$portalConfiguration.startpage ?? ''}>Startseite</a>&nbsp;|&nbsp;<a id="linkImpressum" href={$portalConfiguration.imprint ?? ''} rel="noreferrer" target="_blank">Impressum</a>&nbsp;|&nbsp;<a id="linkKontakt" href={$portalConfiguration.contact ?? ''} rel="noreferrer" target="_blank">Kontakt</a>&nbsp;|&nbsp;<a id="linkDatenschutz" href={$portalConfiguration.dataProtection ?? ''} rel="noreferrer" target="_blank">Datenschutz</a>
    </div>

    <div class="brak-version" style="float: right;">
        {$portalConfiguration.version ?? ''}, {$portalConfiguration.hostname ?? ''}
    </div>

    <div style="clear: both"></div>
</footer>

<TokenAdministrationModal bind:showModal={showCertificateAdministration} />

<svelte:window onkeydown={(e) => {
    if (e.key === 'F1') {
        window.open(`${$portalConfiguration.help}/einrichtung-von-bea/registrieren-und-anmelden/anmelden`, '_blank');
    }
}}/>

<style>
    footer {
        background-color: var(--brak-white);
    }

    footer,
    footer a {
        color: var(--brak-dark-blue);
    }

    footer > div {
        padding-left: var(--brak-site-padding);
        padding-right: var(--brak-site-padding);
    }

    .brak-bea-logo {
        position: relative;
        top: -20px;
        left: var(--brak-site-padding);
    }

    .brak-bea-logo img {
        width: 106px;
    }

    .brak-linkbanner {
        display: grid;
        grid-auto-columns: 1fr;
        grid-auto-rows: 1fr;

        padding-top: 10px;
        padding-bottom: 10px;
        margin-bottom: 10px;

        background-color: var(--brak-dark-blue);
        color: var(--brak-greyed-white);
    }

    .brak-linkbanner > .left {
        grid-column-start: 1;
        line-height: calc((3 * var(--brak-footer-linkbanner-line-height)) / 2);
    }

    .brak-linkbanner > .right {
        text-align: right;
        grid-column-start: 2;
        line-height: var(--brak-footer-linkbanner-line-height);
    }

    .brak-linkbanner a {
        color: var(--brak-greyed-white);
        text-decoration: none;
    }

    .brak-linkbanner a:hover {
        color: var(--brak-greyed-white);
        text-decoration: underline;
    }

    .link-button {
        padding: 0;
        border: 0;
        background: none;
        color: inherit;
    }

    .brak-linkbanner .link-button:hover {
        color: var(--brak-greyed-white);
        text-decoration: underline;
    }

    .brak-copyright,
    .brak-version {
        font-size: var(--brak-copyright-font-size);
    }

    .brak-copyright a {
        text-decoration: underline;
    }

    .disable {
        cursor: not-allowed;
        color: var(--brak-medium-blue);
    }
</style>
